import { fetchApi } from '@/config/axiosSetting';
import {
  GetSignatureQueryParamsResponseType,
  GetSignatureQueryParamsType,
} from '@/modules/adjusterReportModules/queries/getSignature/getSignatureQuery.type';

export const getBodySignatureQueryFunction = (
  params: GetSignatureQueryParamsType,
): Promise<GetSignatureQueryParamsResponseType> => {
  return fetchApi.get(`/body/reports/${params.id}/images/signature/`);
};
